import { cardTitle, title } from "assets/jss/material-kit-react.jsx";
import imagesStyle from "assets/jss/material-kit-react/imagesStyles.jsx";

const teamStyle = {
  section: {
    padding: "70px 0px",
    textAlign: "center",
    backgroundColor: "#e5e5e5",
    // backgroundImage: `url(${withDogPhoto})`,
    // backgroundSize: "cover",
    // backgroundPosition: "40% 50%",
    "@media (min-width: 576px)": {
    },
    "@media (min-width: 768px)": {
      padding: "70px",
    },
    "@media (min-width: 992px)": {
    },
    "@media (min-width: 1200px)": {
    }
  },
  title: {
    ...title,
    color: "#3C4858",
    marginBottom: "1rem",
    marginTop: "30px",
    minHeight: "32px",
    textDecoration: "none",
    textAlign: "left",
    paddingLeft: "30px",
    paddingRight: "30px"
  },
  ...imagesStyle,
  itemGrid: {
    marginLeft: "auto",
    marginRight: "auto",
    marginTop: "-66px"
  },
  card: {
    borderRadius: "0px",
    backgroundColor: "white",
    marginTop: "66px",
    "@media (min-width: 576px)": {
    },
    "@media (min-width: 768px)": {
      borderRadius: "6px",
    },
    "@media (min-width: 992px)": {
    },
    "@media (min-width: 1200px)": {
    }
  },
  cardTitle,
  smallTitle: {
    color: "#6c757d"
  },
  cardBody: {
    textAlign: "left",
    overflow: "hidden",
    "&:first-of-type": {
      paddingBottom: "0px"
    },
    "&:last-of-type": {
      paddingTop: "0px"
    },
    "& a": {
      cursor: "pointer" 
    }
  },
  cardFooter: {

  },
  description: {
    color: "#777"
  },
  justifyCenter: {
    justifyContent: "center !important"
  },
  socials: {
    marginTop: "0",
    width: "100%",
    transform: "none",
    left: "0",
    top: "0",
    height: "100%",
    lineHeight: "41px",
    fontSize: "20px",
    color: "#999"
  },
  margin5: {
    margin: "5px"
  },
  openCloseButton: {
    display: "float",
    float: "right"
  }
};

export default teamStyle;
